import type { RootSearch } from '@/routes/__root'

export type Platform = 'gallery' | 'upptacka' | 'web'
export function getPlatform({ origin, ipexGallery }: RootSearch): Platform {
  if (origin) return 'upptacka'
  if (ipexGallery) return 'gallery'
  return 'web'
}
